module.exports = __webpack_public_path__ + "static/img/one.9a9d8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/one.png
// module id = /0/F
// module chunks = 1